import _ from 'lodash';
import update from 'immutability-helper';
import {
  FETCH_TESTIMONIAL_REQUEST,
  FETCH_TESTIMONIAL_SUCCESS,
  FETCH_TESTIMONIAL_FAILURE,
  DELETE_TESTIMONIAL_SUCCESS,
  UPDATE_TESTIMONIAL_SUCCESS,
  UPLOAD_TESTIMONIAL_AVATAR_SUCCESS,
} from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  testimonials: [],
};

export default function testimonial(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_TESTIMONIAL_REQUEST:
      return update(state, { isLoading: { $set: true } });
    case FETCH_TESTIMONIAL_SUCCESS:
      return update(state, {
        isLoading: { $set: false },
        testimonials: { $set: action.data },
      });
    case FETCH_TESTIMONIAL_FAILURE:
      return update(state, { isLoading: { $set: false } });
    case DELETE_TESTIMONIAL_SUCCESS: {
      const newTestimonials = _.clone(state.testimonials);
      _.remove(newTestimonials, { id: action.id });
      return update(state, { testimonials: { $set: newTestimonials } });
    }
    case UPDATE_TESTIMONIAL_SUCCESS: {
      const idx = _.findIndex(state.testimonials, { id: action.id });
      return update(state, { testimonials: { [idx]: { $merge: action.testimonial } } });
    }
    case UPLOAD_TESTIMONIAL_AVATAR_SUCCESS: {
      const idx = _.findIndex(state.testimonials, { id: action.id });
      return update(state, { testimonials: { [idx]: { avatar: { $set: action.avatar } } } });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/testimonial.js